import script from "./ClassAnalysis.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClassAnalysis.vue?vue&type=script&setup=true&lang=ts"

import "./ClassAnalysis.vue?vue&type=style&index=0&id=bc963bd8&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc963bd8"]])

export default __exports__